import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Combina classes condicionais e resolve conflitos do Tailwind. */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/** Formata número como moeda BRL. */
export function formatBRL(value) {
  const n = Number(value ?? 0)
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/** Formata CNPJ como 00.000.000/0000-00; devolve o valor original se não tiver 14 dígitos. */
export function formatCnpj(cnpj) {
  const d = String(cnpj ?? '').replace(/\D/g, '')
  if (d.length !== 14) return cnpj || ''
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

/** Aplica a máscara de CNPJ progressivamente, conforme o usuário digita. */
export function maskCnpj(value) {
  const d = String(value ?? '').replace(/\D/g, '').slice(0, 14)
  if (d.length <= 2) return d
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

/** Aplica a máscara de CEP (00.000-000) progressivamente. */
export function maskCep(value) {
  const d = String(value ?? '').replace(/\D/g, '').slice(0, 8)
  if (d.length <= 2) return d
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
  return `${d.slice(0, 2)}.${d.slice(2, 5)}-${d.slice(5)}`
}

/** Máscaras disponíveis para os campos dos formulários (ver `field.mask`). */
export const masks = { cnpj: maskCnpj, cep: maskCep }

/** Formata data ISO (AAAA-MM-DD) para dd/mm/aaaa. */
export function formatDate(iso) {
  if (!iso) return ''
  const [y, m, d] = String(iso).slice(0, 10).split('-')
  if (!y || !m || !d) return iso
  return `${d}/${m}/${y}`
}
